import React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode; 
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Pehle yahan sirf "Something went wrong." tha — customer ke saamne ek
      // khaali line, koi raasta nahi.
      return (
        <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-4 text-center">
          <b className="text-[18px]">Kuch gadbad ho gayi.</b>
          <p className="max-w-[420px] text-[14px] text-ci-muted">
            Page load nahi ho paya. Ek baar refresh karein — problem bani rahe to
            WhatsApp par bata dein, hum rate bhej denge.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="h-[42px] rounded-md bg-ci-navy px-5 text-[15px] font-semibold text-white"
          >
            Refresh karein
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
